import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderList } from '@openng/optimus-ui/orderlist';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { DeleteButtonComponent } from '../../../../../components/kit/button/delete-button.component';

@Component({
    selector: 'app-nursing-diagnosis-tab',
    templateUrl: './nursing-diagnosis-tab.component.html',
    imports: [
        OrderList,
        PrimeTemplate,
        TranslatePipe,
        ButtonComponent,
        Tooltip,
        DeleteButtonComponent,
    ],
})
export class NursingDiagnosisTabComponent {
    @Input() items: any[] = [];
    @Input() title: string = '';
    @Input() tooltip: string = '';

    @Output() add = new EventEmitter<void>();
    @Output() edit = new EventEmitter<any>();
    @Output() remove = new EventEmitter<any>();
}
